import React, { useState, useEffect } from 'react';
import { Button } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { errorCatch, GET, JSXMap, Overlay, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { FullscreenExitOutlined, FullscreenOutlined, PrinterOutlined, RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import { UserName2Line } from '../../../../common/User';
import Icofont from 'react-icofont';
import { Value } from '../../../components/EventsByIDBlock';

const PlusMinus = (val) => {
	switch (val) {
		case 1:
			return (<Icofont icon="plus" style={{ fontSize: "14px" }} />);
		case -1:
			return (<Icofont icon="minus" style={{ fontSize: "16px", fontWeight: "600" }} />);
		default:
			return (<></>);
	}
};

export default function OtchetSudeiskogoKomiteta(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	let navigate = useNavigate();

	const { auth } = props;
	const { eventid } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [reportData, setReportData] = useState();
	const [transposeReport, setTransposeReport] = useState(false)
	const [fullScreenReport, setFullScreenReport] = useState(false)

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/otchetsudeiskogokomiteta/sudeiskienesootvetstviya/${eventid}`, ({ data }) => {
			if (data?.length) {
				setReportData(data)
			} else {
				setReportData()
			}
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)

	const renderReport = (items) => {
		//Предобработка (собираем всех проверяющих для шапки)
		let judge = []
		let judgeMap = {}
		for (let j = 0; j < items?.length; j++) {
			const item = items[j];

			for (let i = 0; i < item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length; i++) {
				const element = item.otsenkiSudeiDlyaOtchetaStrokaOtcheta[i];
				judgeMap[element?.judgeID] = element?.judge
			}
		}
		for (const key in judgeMap) {
			if (Object.prototype.hasOwnProperty.call(judgeMap, key)) {
				const element = judgeMap[key];
				element.difMinus = 0
				element.difPlus = 0
				element.countOtsenok = 0
				judge.push(element)
			}
		}
		judge.sort((a, b) => (a?.ID - b?.ID))

		for (let j = 0; j < items?.length; j++) {
			const item = items[j];

			for (let c = 0; c < judge.length; c++) {
				const judgeItem = judge[c];
				let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
				judgeItem.isJudged = true;
				if (itemVal) {
					judgeItem.countOtsenok++
				}

				let otsenka = itemVal?.otsenka;
				let min = item?.min;
				let max = item?.max
				let dif = '';
				if (otsenka < min) {
					dif = otsenka - min;
				} else if (otsenka > max) {
					dif = otsenka - max;
				}

				if (dif != '') {
					if (dif < 0) {
						judgeItem.difMinus += dif
					} else if (dif > 0) {
						judgeItem.difPlus += dif
					}
				}
				// console.log(itemVal, dif, judgeItem.difMinus, judgeItem.difPlus);
				if (itemVal?.tipOtsenkiID == 1) {
					otsenka = PlusMinus(otsenka);
				}
			}
		}

		if (transposeReport) {
			return (<div>
				<div className='scrollable' style={{ backgroundColor: "white" }}>
					<table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
						<thead>
							<tr>
								<th colSpan={6} className={`fixed height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
										<div style={{ fontWeight: "bold" }}>Категория</div>
										<div>Тур</div>
									</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
										{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
											<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
												<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>
													№{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
												</div>
											</div>
										</div>}
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
										<div className="bg bg-grey">
											<UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} />
										</div>
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", maxWidth: "110px", backgroundColor: "white" }}>
										{(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											// width: "110px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
										</div>}
										{(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											// width: "110px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											{item?.criterionParams?.name}
										</div>}
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="fixed height-4" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className="bg bg-blue dark-1">Оценка</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<React.Fragment key={cidx}>
										{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th key={cidx+"0"}colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<div className="bg bg-blue dark-1">Оценка</div>
										</th>}
										{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment key={cidx+"1"}>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<div className="bg bg-blue dark-1">Мин.</div>
											</th>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<div className="bg bg-blue dark-1">Макс.</div>
											</th>
										</React.Fragment>}
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<th className="fixed height-4" style={{ minWidth: "150px" }}>
									<div className="bg bg-green dark-17">
										ИТОГО
									</div>
								</th>
								<th className="fixed height-4" style={{ left: "150px", minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>⁰⏨</div>
								</th>
								<th className="fixed height-4" style={{ left: "210px", minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>∑</div>
								</th>
								<th className="fixed height-4" style={{ left: "270px", minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>=</div>
								</th>
								<th className="fixed height-4" style={{ left: "330px", minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>+</div>
								</th>
								<th className="fixed height-4" style={{ left: "390px", minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>-</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<React.Fragment key={cidx}>
										{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</th>}
										{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
													criterion={item?.criterionParams}
													disabled={true}
													colorClass={`bg-blue border-transparent`}
												></Value>
											</th>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
													criterion={item?.criterionParams}
													disabled={true}
													colorClass={`bg-blue border-transparent`}
												></Value>
											</th>
										</React.Fragment>}
									</React.Fragment>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "12px" }}>
							{JSXMap(judge || [], (judgeItem, cidx) => {
								return (<tr key={cidx}>
									<td  className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
										<div className="bg bg-grey dark-1">
											<div>{judgeItem?.user?.lastname}</div>
											<div>{judgeItem?.user?.firstname}</div>
										</div>
									</td>
									<td className="fixed height-8" style={{ left: "150px", minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}
										</div>
									</td>
									<td className="fixed height-8" style={{ left: "210px", minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}
										</div>
									</td>
									<td className="fixed height-8" style={{ left: "270px", minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}
										</div>
									</td>
									<td className="fixed height-8" style={{ left: "330px", minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}
										</div>
									</td>
									<td className="fixed height-8" style={{ left: "390px", minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}
										</div>
									</td>
									{JSXMap(items || [], (item, cidx) => {
										let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
										let otsenka = itemVal?.otsenka;
										let min = item?.min;
										let max = item?.max
										let dif = 0;
										if (otsenka < min) {
											dif = otsenka - min;
										} else if (otsenka > max) {
											dif = otsenka - max;
										}

										// if (dif != '') {
										//     if (dif < 0) {
										//         judgeItem.difMinus += dif
										//     } else if (dif > 0) {
										//         judgeItem.difPlus += dif
										//     }
										// }

										// if (itemVal?.tipOtsenkiID == 1) {
										//     otsenka = PlusMinus(otsenka);
										// }

										return (<td key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
											<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
										</td>)
									})}

								</tr>)
							})}
						</tbody>
					</table>
				</div>
			</div>)
		}
		if (!transposeReport) {
			return (<div>
				<div className='scrollable' style={{ backgroundColor: "white" }}>
					<table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
						<thead>
							<tr>
								<th className={`fixed height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
										<div style={{ fontWeight: "bold" }}>Категория</div>
										<div>Тур</div>

									</div>
								</th>
								{/* <th className="fixed height-8" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                                <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Тур</div>
                            </th> */}
								<th className="fixed height-8" style={{ left: "150px", minWidth: "110px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
								</th>
								<th className="fixed height-8" style={{ left: "260px", minWidth: "100px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
								</th>
								<th className="height-8">
									<div className="bg bg-blue dark-1">Оценка (мин.)</div>
								</th>
								<th className="height-8">
									<div className="bg bg-blue dark-1">Оценка (макс.)</div>
								</th>
								{JSXMap(judge || [], (item, cidx) => {
									return (<th key={cidx} className="height-8" style={{ minWidth: "85px" }}>
										<div className="bg bg-grey dark-1">
											<div>{item?.user?.lastname}</div>
											<div>{item?.user?.firstname}</div>
										</div>
									</th>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "12px" }}>
							{JSXMap(items || [], (item, cidx) => {
								return (<tr key={cidx}>
									<td className="fixed height-5" style={{ minWidth: "150px", backgroundColor: "white" }}>
										{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
											<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
												<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>
													№{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
												</div>
											</div>
										</div>}
									</td>
									{/* <td className="fixed height-5" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                                    {item?.dancerTour?.tour && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                        <div style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}>
                                            №{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
                                        </div>
                                    </div>}
                                </td> */}
									<td className={`fixed height-5`} style={{ left: "150px", minWidth: "110px", backgroundColor: "white" }}>
										<div className="bg bg-grey">
											<UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} />
										</div>
									</td>
									<td className={`fixed height-5`} style={{ left: "260px", minWidth: "100px", backgroundColor: "white" }}>
										{(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											width: "200px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
										</div>}
										{(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											width: "200px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											{item?.criterionParams?.name}
										</div>}
									</td>
									{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <td colSpan={2} className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
										<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
											criterion={item?.criterionParams}
											disabled={true}
											colorClass={`bg-blue border-transparent`}
										></Value>
									</td>}
									{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
										<td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</td>
										<td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</td>
									</React.Fragment>}
									{JSXMap(judge || [], (judgeItem, cidx) => {
										let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
										let otsenka = itemVal?.otsenka;
										let min = item?.min;
										let max = item?.max
										let dif = 0;
										if (otsenka < min) {
											dif = otsenka - min;
										} else if (otsenka > max) {
											dif = otsenka - max;
										}

										// if (dif != '') {
										//     if (dif < 0) {
										//         judgeItem.difMinus += dif
										//     } else if (dif > 0) {
										//         judgeItem.difPlus += dif
										//     }
										// }

										// if (itemVal?.tipOtsenkiID == 1) {
										//     otsenka = PlusMinus(otsenka);
										// }
										return (<React.Fragment key={"a" + cidx}>
											{(itemVal?.tipOtsenkiID == 1) && <td className="height-5">
												<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
											</td>}
											{(itemVal?.tipOtsenkiID != 1) && <td className="height-5">
												<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
											</td>}
										</React.Fragment>)
									})}
								</tr>)
							})}
							<tr>
								<td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в плюс)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в минус)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (по модулю)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Общее количество проверяемых оценок</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Коэффициент отклонений</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
						</tbody>
					</table>
				</div>
			</div>)
		}

	}

	const renderReportMobile = (items) => {
		//Предобработка (собираем всех проверяющих для шапки)
		let judge = []
		let judgeMap = {}
		for (let j = 0; j < items?.length; j++) {
			const item = items[j];

			for (let i = 0; i < item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length; i++) {
				const element = item.otsenkiSudeiDlyaOtchetaStrokaOtcheta[i];
				judgeMap[element?.judgeID] = element?.judge
			}
		}
		for (const key in judgeMap) {
			if (Object.prototype.hasOwnProperty.call(judgeMap, key)) {
				const element = judgeMap[key];
				element.difMinus = 0
				element.difPlus = 0
				element.countOtsenok = 0
				judge.push(element)
			}
		}
		judge.sort((a, b) => (a?.ID - b?.ID))

		for (let j = 0; j < items?.length; j++) {
			const item = items[j];

			for (let c = 0; c < judge.length; c++) {
				const judgeItem = judge[c];
				let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
				judgeItem.isJudged = true;
				if (itemVal) {
					judgeItem.countOtsenok++
				}

				let otsenka = itemVal?.otsenka;
				let min = item?.min;
				let max = item?.max
				let dif = '';
				if (otsenka < min) {
					dif = otsenka - min;
				} else if (otsenka > max) {
					dif = otsenka - max;
				}

				if (dif != '') {
					if (dif < 0) {
						judgeItem.difMinus += dif
					} else if (dif > 0) {
						judgeItem.difPlus += dif
					}
				}
				// console.log(itemVal, dif, judgeItem.difMinus, judgeItem.difPlus);
				if (itemVal?.tipOtsenkiID == 1) {
					otsenka = PlusMinus(otsenka);
				}
			}
		}

		if (transposeReport) {
			return (<div>
				<div className='scrollable' style={{ backgroundColor: "white" }}>
					<table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
						<thead>
							<tr>
								<th colSpan={6} className={`height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
										<div style={{ fontWeight: "bold" }}>Категория</div>
										<div>Тур</div>
									</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
										{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
											<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
												<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>
													№{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
												</div>
											</div>
										</div>}
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
										<div className="bg bg-grey">
											<UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} />
										</div>
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", maxWidth: "110px", backgroundColor: "white" }}>
										{(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											// width: "110px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
										</div>}
										{(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											// width: "110px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											{item?.criterionParams?.name}
										</div>}
									</th>)
								})}
							</tr>
							<tr>
								<th colSpan={6} className="height-4" style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className="bg bg-blue dark-1">Оценка</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<React.Fragment key={cidx}>
										{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<div className="bg bg-blue dark-1">Оценка</div>
										</th>}
										{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<div className="bg bg-blue dark-1">Мин.</div>
											</th>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<div className="bg bg-blue dark-1">Макс.</div>
											</th>
										</React.Fragment>}
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<th className="height-4" style={{ minWidth: "150px" }}>
									<div className="bg bg-green dark-17">
										ИТОГО
									</div>
								</th>
								<th className="height-4" style={{ minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>⁰⏨</div>
								</th>
								<th className="height-4" style={{ minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>∑</div>
								</th>
								<th className="height-4" style={{ minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>=</div>
								</th>
								<th className="height-4" style={{ minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>+</div>
								</th>
								<th className="height-4" style={{ minWidth: "60px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>-</div>
								</th>
								{JSXMap(items || [], (item, cidx) => {
									return (<React.Fragment key={cidx}>
										{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</th>}
										{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
													criterion={item?.criterionParams}
													disabled={true}
													colorClass={`bg-blue border-transparent`}
												></Value>
											</th>
											<th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
												<Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
													criterion={item?.criterionParams}
													disabled={true}
													colorClass={`bg-blue border-transparent`}
												></Value>
											</th>
										</React.Fragment>}
									</React.Fragment>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "12px" }}>
							{JSXMap(judge || [], (judgeItem, cidx) => {
								return (<tr key={cidx}>
									<td  className="height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
										<div className="bg bg-grey dark-1">
											<div>{judgeItem?.user?.lastname}</div>
											<div>{judgeItem?.user?.firstname}</div>
										</div>
									</td>
									<td className="height-8" style={{ minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}
										</div>
									</td>
									<td className="height-8" style={{ minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}
										</div>
									</td>
									<td className="height-8" style={{ minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}
										</div>
									</td>
									<td className="height-8" style={{ minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}
										</div>
									</td>
									<td className="height-8" style={{ minWidth: "60px", backgroundColor: "white" }}>
										<div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
											{(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}
										</div>
									</td>

									{JSXMap(items || [], (item, cidx) => {
										let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
										let otsenka = itemVal?.otsenka;
										let min = item?.min;
										let max = item?.max
										let dif = 0;
										if (otsenka < min) {
											dif = otsenka - min;
										} else if (otsenka > max) {
											dif = otsenka - max;
										}

										// if (dif != '') {
										//     if (dif < 0) {
										//         judgeItem.difMinus += dif
										//     } else if (dif > 0) {
										//         judgeItem.difPlus += dif
										//     }
										// }

										// if (itemVal?.tipOtsenkiID == 1) {
										//     otsenka = PlusMinus(otsenka);
										// }

										return (<td key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
											<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
										</td>)
									})}

								</tr>)
							})}
						</tbody>
					</table>
				</div>
			</div>)
		}
		if (!transposeReport) {
			return (<div>
				<div className='scrollable' style={{ backgroundColor: "white" }}>
					<table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
						<thead>
							<tr>
								<th className={`height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
										<div style={{ fontWeight: "bold" }}>Категория</div>
										<div>Тур</div>

									</div>
								</th>
								<th className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
								</th>
								<th className="height-8" style={{ minWidth: "100px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
								</th>
								<th className="height-8">
									<div className="bg bg-blue dark-1">Оценка (мин.)</div>
								</th>
								<th className="height-8">
									<div className="bg bg-blue dark-1">Оценка (макс.)</div>
								</th>
								{JSXMap(judge || [], (item, cidx) => {
									return (<th key={cidx} className="height-8" style={{ minWidth: "85px" }}>
										<div className="bg bg-grey dark-1">
											<div>{item?.user?.lastname}</div>
											<div>{item?.user?.firstname}</div>
										</div>
									</th>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "12px" }}>
							{JSXMap(items || [], (item, cidx) => {
								return (<tr key={cidx}>
									<td className="height-5" style={{ minWidth: "150px", backgroundColor: "white" }}>
										{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
											<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
												<div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
												<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>
													№{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
												</div>
											</div>
										</div>}
									</td>
									<td className={`height-5`} style={{ minWidth: "110px", backgroundColor: "white" }}>
										<div className="bg bg-grey">
											<UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} />
										</div>
									</td>
									<td className={`height-5`} style={{ minWidth: "100px", backgroundColor: "white" }}>
										{(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											width: "200px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
											<div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
										</div>}
										{(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
											// whiteSpace: "nowrap",
											width: "200px",
											whiteSpace: "normal",
											overflow: "hidden",
											textOverflow: "ellipsis",
											textAlign: "left"
										}}>
											{item?.criterionParams?.name}
										</div>}
									</td>
									{(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <td colSpan={2} className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
										<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
											criterion={item?.criterionParams}
											disabled={true}
											colorClass={`bg-blue border-transparent`}
										></Value>
									</td>}
									{(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
										<td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</td>
										<td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
											<Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
												criterion={item?.criterionParams}
												disabled={true}
												colorClass={`bg-blue border-transparent`}
											></Value>
										</td>
									</React.Fragment>}
									{JSXMap(judge || [], (judgeItem, cidx) => {
										let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
										let otsenka = itemVal?.otsenka;
										let min = item?.min;
										let max = item?.max
										let dif = 0;
										if (otsenka < min) {
											dif = otsenka - min;
										} else if (otsenka > max) {
											dif = otsenka - max;
										}

										// if (dif != '') {
										//     if (dif < 0) {
										//         judgeItem.difMinus += dif
										//     } else if (dif > 0) {
										//         judgeItem.difPlus += dif
										//     }
										// }

										// if (itemVal?.tipOtsenkiID == 1) {
										//     otsenka = PlusMinus(otsenka);
										// }
										return (<React.Fragment key={"a" + cidx}>
											{(itemVal?.tipOtsenkiID == 1) && <td className="height-5">
												<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
											</td>}
											{(itemVal?.tipOtsenkiID != 1) && <td className="height-5">
												<div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
											</td>}
										</React.Fragment>)
									})}
								</tr>)
							})}
							<tr>
								<td colSpan={3} className="height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в плюс)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в минус)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (по модулю)</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Общее количество проверяемых оценок</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
							<tr>
								<td colSpan={3} className="height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
									<div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Коэффициент отклонений</div>
								</td>
								<td colSpan={2} className="height-5">
									<div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
								</td>
								{JSXMap(judge || [], (judgeItem, cidx) => {
									return (<React.Fragment key={"a" + cidx}>
										<td className="height-5">
											<div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}</div>
										</td>
									</React.Fragment>)
								})}
							</tr>
						</tbody>
					</table>
				</div>
			</div>)
		}

	}

	if (isDesktopOrLaptop || !isMobile) {
		// console.log("desktop");
		return (
			<div style={{ padding: "15px 20px" }}>
				{/* <div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
					<ReactToPrint
						trigger={() => {
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
						}}
						content={() => ref.current}
					/>
				</div> */}
				{(reportData) &&
					<Overlay open={fullScreenReport} setOpen={setFullScreenReport}>
						<div>
							<div style={{ display: "flex", justifyContent: "right", gap: "5px", paddingBottom: "10px" }}>
								<ReactToPrint
									trigger={() => {
										return (<div className={`bg $bg-grey pointer`}
											style={{
												minWidth: "28px",
												fontSize: "14px",
												lineHeight: "22px",
												color: "black",
											}}
										>
											<PrinterOutlined />
										</div>)
									}}
									content={() => ref.current}
								/>
								<div className={`bg ${(transposeReport) ? "bg-altblue" : "bg-grey"} pointer`}
									style={{
										minWidth: "28px",
										fontSize: "14px",
										lineHeight: "22px",
										color: (transposeReport) ? "white" : "black",
									}}
									onClick={(e) => { (transposeReport) ? setTransposeReport(false) : setTransposeReport(true) }}
								>
									{(!transposeReport) && <RotateRightOutlined />}
									{(transposeReport) && <RotateLeftOutlined />}
								</div>
								<div className={`bg ${(fullScreenReport) ? "bg-altblue" : "bg-grey"} pointer`}
									style={{
										minWidth: "28px",
										fontSize: "14px",
										lineHeight: "22px",
										color: (fullScreenReport) ? "white" : "black",
									}}
									onClick={(e) => { (fullScreenReport) ? setFullScreenReport(false) : setFullScreenReport(true) }}
								>
									{(!fullScreenReport) && <FullscreenOutlined />}
									{(fullScreenReport) && <FullscreenExitOutlined />}
								</div>
							</div>
							{(reportData) && <div className="report" style={{ padding: "0 5px" }} ref={ref}>
								{renderReport(reportData)}
							</div>}
						</div>
					</Overlay>
				}
			</div >);
	} else {
		// console.log("mobile"); 
		return (
			<div>
				<div style={{ display: "flex", gap: "5px", justifyContent: ((eventid) ? "space-between" : "right"), padding: "15px 10px" }} >
					{(eventid) && <Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }} onClick={(e) => {
						navigate(-1);
					}}><i className='fa fa-chevron-left'></i></Button>}
					<ReactToPrint trigger={() => (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /></Button>)} content={() => ref.current} />
					<div className={`bg ${(transposeReport) ? "bg-altblue" : "bg-grey"} pointer`}
						style={{
							minWidth: "28px",
							fontSize: "14px",
							lineHeight: "22px",
							color: (transposeReport) ? "white" : "black",
						}}
						onClick={(e) => { (transposeReport) ? setTransposeReport(false) : setTransposeReport(true) }}
					>
						{(!transposeReport) && <RotateRightOutlined />}
						{(transposeReport) && <RotateLeftOutlined />}
					</div>
				</div>
				{(reportData) && <div className="report" style={{ padding: "0 5px" }} ref={ref}>
					{renderReportMobile(reportData)}
				</div>}
			</div >);
	}
}
